import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { DeleteBesichtigungsStatusCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [DeleteBesichtigungsStatusCommandService],
  exports: []
})
export class DeleteBesichtigungsStatusCommandServiceModule { }
